import React from 'react';
// components
import BaseSelect from 'src/shared/components/inputs/BaseSelect';

const FixedValueSelectLookup = ({ fixedValueProps, name, value, setFieldValue, defaultItem, readOnly }) => {
  const { fixedValues, lookupValueName, lookupDisplayName  } = fixedValueProps;

  const fieldMapper = (fieldValue) => {
    if (!fieldValue) {
      return null;
    }

    if (lookupValueName && fieldValue[lookupValueName]) {
      return fieldValue[lookupValueName]
    }

    const { id, name, carrierName, text, abbreviation, value, portName, displayName } = fieldValue;
    return {
      label: name || carrierName || text || abbreviation || portName || displayName || '',
      value: id || value,
    };
  };

  let defaultValue = {};

  if (defaultItem) {
    const foundItem = fixedValues?.find((x) => x.id === parseInt(defaultItem) || x.value === parseInt(defaultItem));
    if (foundItem) {
      defaultValue = fieldMapper(foundItem);
    }
  }

  return (
    <BaseSelect
      onChange={({ value }) => setFieldValue(value?.value)}
      label=''
      textField={lookupDisplayName || 'label'}
      data={fixedValues?.map(fieldMapper)}
      name={name}
      value={fieldMapper(fixedValues?.find((v) => v.id === parseInt(value) || v.value === parseInt(value)))}
      defaultItem={defaultValue}
      isCombo
      readOnly={readOnly}
    />
  );
};

export default FixedValueSelectLookup;
